'use strict';

const Reflux = require('@muzzylane/reflux');

const TemplatePermissionActions = require('../actions/TemplatePermissionActions');
const SignInStore = require('./SignInStore');
const ForgeError = require('../util/error');
const SignInActions = require('../actions/sign_in_actions');

let permissions = {};

let action = {};
let error = null;

const TemplatePermissionStore = Reflux.createStore({
    listenables: [TemplatePermissionActions, SignInActions],
    init: function() {},

    resetState: function() {
        permissions = {};
        // action = {};
        // error = null;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            permissions: permissions,
            action: action,
            error: error
        };
    },

    emitStatus: function() {
        this.trigger(this.getState());
    },

    onAddTemplatePermissionCompleted: function(actionId, userId, res) {
        // console.log("onAddTemplatePermissionCompleted:", actionId, userId, res);
        action = { id: actionId };
        permissions[userId] = res;
        this.emitStatus();
    },

    onAddTemplatePermissionFailed: function(actionId, userId, err) {
        console.log("onAddTemplatePermissionFailed:", actionId, userId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetUserTemplatePermissionsCompleted: function(actionId, userId, res) {
        // console.log("onGetUserTemplatePermissionsCompleted", actionId, userId, res);
        action = { id: actionId };
        permissions[userId] = res;
        this.emitStatus();
    },

    onGetUserTemplatePermissionsFailed: function(actionId, userId, err) {
        console.warn("onGetUserTemplatePermissionsFailed", actionId, userId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteUserTemplatePermissionsCompleted: function(actionId, userId, res) {
        // console.log("onDeleteUserTemplatePermissionsCompleted", actionId, userId, res);
        action = { id: actionId };
        permissions[userId] = res;
        this.emitStatus();
    },

    onDeleteUserTemplatePermissionsFailed: function(actionId, userId, err) {
        console.warn("onDeleteUserTemplatePermissionsFailed", actionId, userId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetProjectTemplatePermissionsCompleted: function(actionId, channelId, res) {
        // console.log("onGetProjectTemplatePermissionsCompleted", actionId, channelId, res);
        action = { id: actionId };
        permissions[channelId] = res;
        this.emitStatus();
    },

    onGetProjectTemplatePermissionsFailed: function(actionId, channelId, err) {
        console.warn("onGetProjectTemplatePermissionsFailed", actionId, channelId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
});

//TODO: listen to OrganizationActions, fetch new template permissions onRegisterOrganizationCompleted for new orgId

module.exports = TemplatePermissionStore;
